import { Component, Inject, Injectable, ElementRef, ViewChild } from '@angular/core';
import { ForumApiService } from 'src/app/service/forum.api.service';
import { HttpClient } from '@angular/common/http';
import { APP_SETTINGS, AppSettings } from 'src/app/settings';
import { EncryptionService } from 'src/app/service/encryption.service';
import { StorageService } from '../service/storage.service';
import { Meta } from '@angular/platform-browser';
import { BottomsheetModalComponent } from './bottomsheet-modal/bottomsheet-modal.component';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { DataService } from '../service/data.service';
import { ConstantService } from '../service/constant.service';
import { CleverTapService } from 'src/app/service/clevertap.service';
import clevertap from 'clevertap-web-sdk';

@Component({
  selector: 'app-forum',
  templateUrl: './forum.component.html',
  styleUrls: ['./forum.component.less'],
})
export class ForumComponent { 
  
  @ViewChild('viewMoreLink') viewMoreLink: ElementRef<HTMLButtonElement>;

  faqData = [];
  categoryId = [];  
  sortedArray = [];
  mainBaseArray = [];
  questionsArray = [];
  finalQuestionArray = [];
  titleArrayForKeywords = [];

  viewChange = this.constantService.viewLess;
  
  questionCount: number;

  isLoggedIn: string;
  mainCategory: string;
  portalNumber: string;
  subCategory: string;
  quaestionsArrayTitle:string;

  panelOpenState = false;
  showLoader: boolean;
  showKBloader: boolean;

  // Phone popup properties
  showPhoneModal: boolean = false;
  phoneNumber: string = '';
  private loginCheckInterval: any;
  private lastLoginStatus: string;

  constructor(
    private http: HttpClient,
    @Inject(APP_SETTINGS) private settings: AppSettings,
    private encryptionService: EncryptionService,
    private forumApiService: ForumApiService,
    private storageService: StorageService,
    private router: Router,
    private meta: Meta,
    private _bottomSheet: MatBottomSheet,
    private titleService: Title,
    private route: ActivatedRoute,
    private dataService: DataService,
    public constantService: ConstantService,
    private cleverTapService: CleverTapService,
  ) { }

  ngOnInit(): void {
    this.isLoggedIn = this.storageService.getItem(this.constantService.isLoggedIn);
    this.lastLoginStatus = this.isLoggedIn; // Store initial login status

    console.log('Faq-v1.2');
    
    const data = this.storageService.getItem('faqData');
    if(data){
      this.faqData = JSON.parse(data);
    }
    
    this.getPortalId();
    this.addMetaTag();
    this.titleService.setTitle(this.constantService.forumPageTitle);

    // Start monitoring login status
    this.startLoginStatusMonitoring();
    
    // Listen for storage changes (login from another tab)
    this.listenForStorageChanges();
  }

  ngOnDestroy(): void {
    // Clean up intervals and listeners
    if (this.loginCheckInterval) {
      clearInterval(this.loginCheckInterval);
    }
    window.removeEventListener('storage', this.handleStorageChange);
  }


  addMetaTag(): void {
    this.meta.updateTag({ name: this.constantService.robots, content: this.constantService.forumPageRobotContent });
    this.meta.updateTag({ name: this.constantService.description, content: this.constantService.forumPageDescription});
  }

  async getPortalId(): Promise<void> {
    try {
      const orgId = this.encryptionService.decryptUsingAES_256(this.settings.orgId);

      await this.forumApiService
        .getPortalId(orgId)
        .then(async (getPortalIdResponse) => {
          if (getPortalIdResponse.data.length > 0) {
            for (let i = 0; i < getPortalIdResponse.data.length; i++) {
              if (getPortalIdResponse.data[i].name == '5paisa') {
                this.portalNumber = getPortalIdResponse.data[i].portalId;
                this.storageService.setItem(
                  this.constantService.portalId,
                  this.encryptionService.encryptUsingAES_256(this.portalNumber)
                );
              }
            }
          }         
        });
          this.knowledgeBase();
    } catch (e) {
      console.group('Error Occured in getPortalId : ', e);
    }
  }

  async knowledgeBase(): Promise<void> {
    try {
      this.showLoader = true;
      this.showKBloader =true;
      const portalId = this.encryptionService.decryptUsingAES_256(this.storageService.getItem(this.constantService.portalId));
      const include = this.constantService.knowledgeBaseRequestInclude;
      await this.forumApiService.knowledgeBase(include, portalId).then(async (knowledgeBaseResponse) => {
        this.showKBloader = false;
          for(let i=0; i<knowledgeBaseResponse.child.length; i++){
            this.mainBaseArray[i] = knowledgeBaseResponse.child[i];
            this.categoryId[i] = this.mainBaseArray[i].id;
            this.titleArrayForKeywords[i] = this.mainBaseArray[i].name;
          }
          this.dataService.sendData(this.mainBaseArray);
          var str = this.titleArrayForKeywords.join(", ");
          this.meta.updateTag({ name: this.constantService.keywords, content: str }); 
      });

      if(this.faqData.length > 0){
        this.showLoader = false;
        this.finalQuestionArray = this.faqData;
        this.questionCount = this.finalQuestionArray.length;
        this.getViewMore(this.constantService.viewLess);
      } else {
        this.frequentlyAskedQuestions();
      }    
      
      // this.frequentlyAskedQuestions();

    } catch (e) {
      this.showLoader = false;
      this.showKBloader = false;
      console.group('Error Occured in knowledgeBase : ', e);
    }
  }

  async frequentlyAskedQuestions(): Promise<void> {
    try {
      this.showLoader = true;
        const portalId = this.encryptionService.decryptUsingAES_256(this.storageService.getItem(this.constantService.portalId));
        const from = this.constantService.faqRequestConstant.faqFrom;
        const limit = this.constantService.faqRequestConstant.faqLimitMax;
        const sortBy = this.constantService.faqRequestConstant.faqSortBy;
        const locale = this.constantService.faqRequestConstant.faqlocale;

        for(let i=0; i<this.categoryId.length; i++) {
          await this.forumApiService.articalList(portalId, this.categoryId[i], from, limit, sortBy, locale).then(async (getArticalListResponse) => {
            this.questionsArray[i] = getArticalListResponse.data;
          });
        }
        
        for(let j=0; j<this.questionsArray.length; j++){
          this.sortedArray[j] = this.questionsArray[j].slice(-2);
        }

        this.finalQuestionArray = [].concat(...this.sortedArray);

        const faqData = JSON.stringify(this.finalQuestionArray);
        this.storageService.setItem('faqData', faqData);

        this.questionCount = this.finalQuestionArray.length;   
        this.showLoader = false;     
        this.getViewMore(this.constantService.viewLess);

    } catch (e) {
      this.showLoader = false;
      console.group('Error Occured in frequentlyAskedQuestions : ', e);
    }    
  }

  goToKnowledgeBaseComponent(cName: string, categoryName: string): void {

    if(this.storageService.getItem(this.constantService.isLoggedIn) == 'Y'){
      clevertap.init('R74-5R4-6W5Z');
      setTimeout(() => {
        const clientId = this.encryptionService.decryptUsingAES_256(this.storageService.getItem(this.constantService.clientCode));
        clevertap.onUserLogin.push({
          "Site": {
              "Identity": clientId
          }
         });
        let clevertapData = {
          action : 'knowledge_base_clicked',
          page_section : 'knowledge base',
          category : categoryName,
          client_code : clientId
        };    
        this.cleverTapService.clevertapCommonFunction('faq_page_click',clevertapData);
      }, 3000);      
    }
    this.router.navigateByUrl(cName);
  }

  goTosubCategoryAnswers(questionId: string, catId: string, questionTitle: string): void {
    this.resolveCategoryPaths(catId);
    this.router.navigate([this.mainCategory + '/' + this.subCategory + '/' + questionTitle], {queryParams: { questionId }});
  }

  onKnowledgeBaseKeydown(event: KeyboardEvent, permalink: string, categoryName: string): void {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.goToKnowledgeBaseComponent(permalink, categoryName);
    }
  }

  private resolveCategoryPaths(catId: string): void {
    for (const mainCat of this.mainBaseArray) {
      for (const subCat of mainCat?.child ?? []) {
        if (subCat.id == catId) {
          this.mainCategory = mainCat.permalink;
          this.subCategory = subCat.permalink;
          return;
        }
      }
    }
  }

  getViewMore(viewChange: string) : void {
    const wasCollapsed = this.viewChange === this.constantService.viewMore;

    if(viewChange == this.constantService.viewLess){
      viewChange = this.constantService.viewMore;
      this.viewChange = this.constantService.viewMore;
    } else {
      viewChange = this.constantService.viewLess;
      this.viewChange = this.constantService.viewLess;
    }

    if(this.viewChange == this.constantService.viewLess || viewChange == this.constantService.viewLess){
      if(this.faqData.length > 0) {
        this.finalQuestionArray = this.faqData; 
      } else {
        this.finalQuestionArray = [].concat(...this.sortedArray);
      }

    } else if(this.viewChange == this.constantService.viewMore || viewChange == this.constantService.viewMore){
      this.finalQuestionArray = this.finalQuestionArray.slice(0, 2);
    }

    if (wasCollapsed && this.viewChange === this.constantService.viewLess) {
      // Focus the first newly revealed FAQ (items 0-1 were already visible).
      setTimeout(() => this.focusNewlyRevealedFaqHeading());
    }
  }

  private focusNewlyRevealedFaqHeading(): void {
    const newlyRevealed = document.getElementById('faq-item-2') as HTMLElement | null;
    const fallback = document.getElementById('faq-item-0') as HTMLElement | null;
    const target = newlyRevealed || fallback;
    target?.focus();
    target?.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  }

  goToCreateTicket(): void {
    try {
      this.isLoggedIn = this.storageService.getItem(this.constantService.isLoggedIn);
      if(this.isLoggedIn == this.constantService.yes) {
        clevertap.init('R74-5R4-6W5Z');
        setTimeout(() => {
          const clientId = this.encryptionService.decryptUsingAES_256(this.storageService.getItem(this.constantService.clientCode));
          clevertap.onUserLogin.push({
            "Site": {
                "Identity": clientId
            }
           });
          let clevertapData = {
            action : 'create_ticket',
            page_section : 'support',
            client_code : clientId
          };
          this.cleverTapService.clevertapCommonFunction('faq_page_click',clevertapData);
        }, 3000);
        this.router.navigateByUrl(this.constantService.navigationComponentPage.createTicket);
      } else {
        this._bottomSheet.open(BottomsheetModalComponent, {
          data: { message: this.constantService.notLoggedInMessage }
        });
      }   
    } catch (e) {
      console.log('Error in goToCreateTicket method - ',e);
    }     
  }

  letsChat(): void {
    this.isLoggedIn = this.storageService.getItem(this.constantService.isLoggedIn);
    console.log(this.constantService.clientCode, this.storageService.getItem(this.constantService.clientCode));
    
    if(this.isLoggedIn == this.constantService.yes) {
      clevertap.init('R74-5R4-6W5Z');
      setTimeout(() => {
        const clientId = this.encryptionService.decryptUsingAES_256(this.storageService.getItem(this.constantService.clientCode));
        clevertap.onUserLogin.push({
          "Site": {
              "Identity": this.constantService.clientCode
          }
         });
        let clevertapData = {
          action : 'chat',
          page_section : 'support',
          client_code : clientId,
        };
        this.cleverTapService.clevertapCommonFunction('faq_page_click',clevertapData);

        window.location.href = `${this.constantService.letsChatBotLink}?id=${clientId}`;
      }, 1000);
      
    } else {
      this._bottomSheet.open(BottomsheetModalComponent, {
        data: { message: this.constantService.notLoggedInMessage }
      });
    }    
  }

  private isMobileDevice(): boolean {
    const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
    
    // Check for mobile user agents
    const mobileRegex = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i;
    
    // Also check screen width as additional indicator
    const isMobileScreen = window.innerWidth <= 768;
    
    return mobileRegex.test(userAgent.toLowerCase()) || isMobileScreen;
  }

  // Phone popup methods
  showPhonePopup(event: Event): void {
    event.preventDefault(); // Prevent default tel: behavior
    
    // Extract phone number from the href attribute
    const target = event.currentTarget as HTMLAnchorElement;
    this.phoneNumber = target.getAttribute('href')?.replace('tel:', '') || '';
    
    // Check if it's mobile device
    if (this.isMobileDevice()) {
      // Direct call on mobile
      this.makeDirectCall();
      return;
    }
    
    // Show popup on web/desktop
    this.showPhoneModal = true;
    
    // Prevent body scrolling
    document.body.style.overflow = 'hidden';

    // Optional: Add CleverTap tracking
    if(this.storageService.getItem(this.constantService.isLoggedIn) == 'Y'){
      clevertap.init('R74-5R4-6W5Z');
      setTimeout(() => {
        const clientId = this.encryptionService.decryptUsingAES_256(this.storageService.getItem(this.constantService.clientCode));
        clevertap.onUserLogin.push({
          "Site": {
              "Identity": clientId
          }
         });
        let clevertapData = {
          action : 'phone_popup_opened',
          page_section : 'support',
          phone_number : this.phoneNumber,
          client_code : clientId,
          device_type : 'desktop'
        };
        this.cleverTapService.clevertapCommonFunction('faq_page_click',clevertapData);
      }, 1000);
    }
  }

  closePhonePopup(): void {
    this.showPhoneModal = false;
    
    // Restore body scrolling
    document.body.style.overflow = 'auto';
  }

  private makeDirectCall(): void {
    if(this.storageService.getItem(this.constantService.isLoggedIn) == 'Y'){
      clevertap.init('R74-5R4-6W5Z');
      setTimeout(() => {
        const clientId = this.encryptionService.decryptUsingAES_256(this.storageService.getItem(this.constantService.clientCode));
        clevertap.onUserLogin.push({
          "Site": {
              "Identity": clientId
          }
         });
        let clevertapData = {
          action : 'direct_call_initiated',
          page_section : 'support',
          phone_number : this.phoneNumber,
          client_code : clientId,
          device_type : 'mobile'
        };
        this.cleverTapService.clevertapCommonFunction('faq_page_click',clevertapData);
      }, 1000);
    }

    // Make direct call
    setTimeout(() => {
      try {
        window.location.href = 'tel:' + this.phoneNumber;
      } catch (error) {
        console.error('Error making call:', error);
        // Fallback
        const link = document.createElement('a');
        link.href = 'tel:' + this.phoneNumber;
        link.click();
      }
    }, 100);
  }

  // Method to start monitoring login status
  private startLoginStatusMonitoring(): void {
    // Check every 5 seconds for login status changes
    this.loginCheckInterval = setInterval(() => {
      this.checkForLoginStatusChange();
    }, 5000);
  }

  // Method to check for login status changes
  private checkForLoginStatusChange(): void {
    const currentLoginStatus = this.storageService.getItem(this.constantService.isLoggedIn);
    
    // If user was not logged in but now is logged in, reload the page
    if (this.lastLoginStatus !== 'Y' && currentLoginStatus === 'Y') {
      console.log('User logged in detected, reloading page...');
      this.reloadPage();
    }
    
    // Update the last known status
    this.lastLoginStatus = currentLoginStatus;
  }

  // Method to listen for storage changes (login from another tab)
  private listenForStorageChanges(): void {
    window.addEventListener('storage', this.handleStorageChange.bind(this));
  }

  // Handle storage change events
  private handleStorageChange = (event: StorageEvent): void => {
    // Check if the login status changed in another tab
    if (event.key === this.constantService.isLoggedIn) {
      const newValue = event.newValue;
      const oldValue = event.oldValue;
      
      // If user logged in from another tab
      if (oldValue !== 'Y' && newValue === 'Y') {
        console.log('User logged in from another tab, reloading page...');
        setTimeout(() => {
          this.reloadPage();
        }, 1000); // Small delay to ensure all data is saved
      }
    }

    // Also check for JWT token changes
    if (event.key === 'jwtTokenForZoho' && event.newValue && !event.oldValue) {
      console.log('JWT token detected from another tab, reloading page...');
      setTimeout(() => {
        this.reloadPage();
      }, 1000);
    }
  }

  // Method to reload the page
  private reloadPage(): void {
    // Clear the reload flag to ensure fresh reload
    this.storageService.removeItem('isReload');
    
    // Add a small delay to ensure storage is cleared
    setTimeout(() => {
      window.location.reload();
    }, 200);
  }
}